import { render, staticRenderFns } from "./WorkFloNoteHistoryCard.vue?vue&type=template&id=e3ebfbf2&scoped=true&"
import script from "./WorkFloNoteHistoryCard.vue?vue&type=script&lang=js&"
export * from "./WorkFloNoteHistoryCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3ebfbf2",
  null
  
)

export default component.exports